module.exports = __webpack_public_path__ + "img/1508993776.60fb1c95.jpg";